import { Icon, SvgIconNames, Toggle } from '@design';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './HighlightsFilters.module.scss';

export interface HighlightsFiltersProps {
  isFetchMostRead: boolean;
  toggleIsFetchMostRead: (nextValue: boolean) => void;
}

export const HighlightsFilters = ({
  isFetchMostRead,
  toggleIsFetchMostRead,
}: HighlightsFiltersProps) => {
  const { t } = useTranslation(['news']);

  const toggleFilters = [
    {
      icon: 'Trending' as SvgIconNames,
      label: t('news:highlightsFilters.mostRead'),
      value: isFetchMostRead,
      toggleFn: toggleIsFetchMostRead,
      testId: 'toggle-btn-most-read',
    },
  ];

  return (
    <div className={styles.highlightsFiltersRoot}>
      <div className={styles.header}>{t('news:highlights')}</div>
      <div>
        {toggleFilters.map(({ icon, label, value, toggleFn, testId }) => {
          return (
            <label className={styles.toggle} key={label}>
              <div className={styles.labelWrapper}>
                <Icon size={14} iconName={icon} fillColor="var(--text-soft)" />
                <div className={styles.label}>{label}</div>
              </div>
              <Toggle
                iconVisibility="none"
                isChecked={value}
                onToggle={toggleFn}
                data-testid={testId}
              />
            </label>
          );
        })}
      </div>
    </div>
  );
};
